import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const forestHillsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Forest Hills Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Forest Hills, Tampa FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_forest_hills_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Forest Hills',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Forest Hills Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take care of the tree work that 
     keeps homes safe throughout <strong>Forest Hills</strong>. This established 
     North Tampa neighborhood lives up to its name mature trees throughout its 
     streets create beautiful shade and character, but also require consistent 
     professional attention to stay safe. Large canopy overhangs, aging trunks, 
     and storm damage all build up fast when trees aren't managed properly.`,

    `We specialize in <strong>large canopy trimming and hazardous tree removal 
     in mature residential neighborhoods</strong> overhanging limbs threatening 
     rooftops and carports, storm weakened oaks, dense growth pressing against 
     fences and structures, and full removals executed carefully on tight 
     residential lots. We work safely and leave your yard clean.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care 
     throughout <strong>Forest Hills</strong> and surrounding 
     <strong>North Tampa</strong> neighborhoods protecting your home 
     and preserving the natural beauty of your property all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Forest Hills, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_ForestHills = () => <LocationPage config={forestHillsConfig} />;
export default Services_ForestHills;
